import { FaHotel, FaGem, FaClipboardCheck, FaCogs } from "react-icons/fa";

const HowItWorks = () => {
  const steps = [
    {
      title: "Discover Venues",
      desc: "Input your requirements & see our recommendations & prices.",
      icon: FaHotel,
    },
    {
      title: "Guided Visits",
      desc: "Visit venues on your own or with our venue expert.",
      icon: FaGem,
    },
    {
      title: "Book Venue",
      desc: "Get final quotes (upto 30% off) and book your venue.",
      icon: FaClipboardCheck,
    },
    {
      title: "Wedding Planning",
      desc: "We manage everything from planning to execution.",
      icon: FaCogs,
    },
  ];

  return (
    <section className="bg-[#fdf7f7] py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-serif text-gray-800">
            How It <span className="text-[#b76d68]">Works</span>
          </h2>

          <p className="text-gray-500 mt-4 font-outfit">
            Simple steps to your dream destination wedding
          </p>

          {/* Decorative Divider */}
          <div className="flex justify-center items-center gap-3 mt-6">
            <div className="w-10 h-[1px] bg-red-300"></div>
            <div className="w-2 h-2 bg-red-400 rounded-full"></div>
            <div className="w-10 h-[1px] bg-red-300"></div>
          </div>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-center">
          {steps.map((item, index) => {
            const Icon = item.icon;

            return (
              <div key={index} className="px-4">
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <Icon size={60} className="text-[#b76d68]" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-quicksand font-semibold text-gray-800 mb-3">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="text-sm font-outfit text-gray-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
